/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Col_LinearInputs */

const en_mk_cmp_col_linear = /** @type {(inputs: Mk_Cmp_Col_LinearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linear`)
};

const id_mk_cmp_col_linear = /** @type {(inputs: Mk_Cmp_Col_LinearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linear`)
};

/**
* | output |
* | --- |
* | "Linear" |
*
* @param {Mk_Cmp_Col_LinearInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_col_linear = /** @type {((inputs?: Mk_Cmp_Col_LinearInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Col_LinearInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_col_linear(inputs)
	return en_mk_cmp_col_linear(inputs)
});